import Sync from 'routes/Settings/Sync/containers/SyncContainer';

export default Sync;
